import * as yup from "yup"

const signupInfoSchema = yup.object({
  firstName: yup.string().required("성을 입력해주세요."),
  lastName: yup.string().required("이름을 입력해주세요."),
  email: yup
    .string()
    .required("이메일을 입력해주세요.")
    .email("이메일 형식이 아닙니다."),
  isEmailValid: yup
    .boolean()
    .required("이메일 중복 확인을 해주세요.")
    .default(false),
  password: yup
    .string()
    .required("비밀번호를 입력해주세요.")
    .matches(
      /^(?=.*[a-z\d!@#$%^&*()])[^A-Z]{8,15}$/,
      "비밀번호는 8~15자의 영문 소문자, 숫자, 특수문자로 입력해주세요."
    ),
  passwordConfirm: yup
    .string()
    .required("비밀번호 확인을 입력해주세요.")
    .oneOf([yup.ref("password")], "비밀번호가 다릅니다."),
  phoneNumber: yup.object({
    mobileCarrier: yup
      .string()
      .required("통신사를 선택해주세요.")
      .oneOf(["SKT", "KT", "LGU+"]),
    phoneNumber: yup.string().required("전화 번호를 입력해주세요."),
  }),
  isPhoneNumberVerified: yup
    .boolean()
    .required("전화 번호 인증을 받아주세요.")
    .default(false),
  position: yup.string().required("신분을 선택해주세요."),
  schoolInfo: yup.object().when("position", (position: string[]) => {
    if (["중학생", "고등학생", "교사"].includes(position[0])) {
      return yup.object({
        school: yup.string().required("소속 학교명을 입력해주세요."),
        grade: yup.string().required("학년을 선택해주세요."),
      })
    } else {
      return yup.object({
        school: yup.string().default(""),
        grade: yup.string().default(""),
      })
    }
  }),
  advertisement: yup.string().required("알게 된 경로를 선택해주세요."),
  agreedPrivacyTerms: yup
    .boolean()
    .required("개인 정보 이용 약관에 동의해주세요.")
    .oneOf([true])
    .default(false),
  agreedServiceTerms: yup
    .boolean()
    .required("서비스 이용 약관에 동의해주세요.")
    .oneOf([true])
    .default(false),
})

export interface signupInfoType {
  firstName: string
  lastName: string
  email: string
  isEmailValid: boolean
  password: string
  passwordConfirm: string
  phoneNumber: {
    mobileCarrier: string
    phoneNumber: string
  }
  isPhoneNumberVerified: boolean
  position: string
  schoolInfo: {
    school: string
    grade: string
  }
  advertisement: string
  agreedPrivacyTerms: boolean
  agreedServiceTerms: boolean
}

export default signupInfoSchema
